import React from 'react';
import { useSelector } from 'react-redux';
import core from '@gin-betting/core';
import { useLocation } from 'react-router';

import type { State } from 'types';
import ui from 'modules/ui';
import useOddsStatisticFetcher from './useOddsStatisticFetcher';

const { getRouteFromPathname } = core.utils;

const {
    selectors: { selectOddsStatisticView },
} = ui;

const Fetcher: React.FC = () => {
    const { pathname } = useLocation();
    const route = getRouteFromPathname(pathname);

    useOddsStatisticFetcher({ route });

    return null;
};

const OddsStatisticFetcher: React.FC = () => {
    const isOddStatisticsEnabled = useSelector(
        (state: State) => selectOddsStatisticView(state).show
    );

    return isOddStatisticsEnabled ? <Fetcher /> : null;
};

export default OddsStatisticFetcher;
